import { render, staticRenderFns } from "./youth-card-button.vue?vue&type=template&id=71e3fa57"
import script from "./youth-card-button.vue?vue&type=script&lang=js"
export * from "./youth-card-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports